<template>
    <main class="md:px-44 px-7">
      <section class="sticky w-full top-0 z-10 bg-greyBackground pb-4">
        <article class="flex justify-between pb-4 pt-8 items-center md:justify-center">
          <router-link
            :to="{
              name: 'Credit Statement Pay Now',
              query: {
                transactionId: queryData.id,
              },
            }"
          >
            <div class="flex gap-2 items-baseline">
              <img
                class="h-4 w-4 md:hidden"
                src="../assets/primary-left-arrow.svg"
                alt="ePayLater"
              />
              <h1 class="justify-self-center heading-text">{{ $route.meta.displayName }}</h1>
            </div>
          </router-link>
          <img
            class="block h-5 md:h-8 w-auto md:hidden"
            src="../assets/logo-primary.svg"
            alt="ePayLater"
            width="132"
            height="28"
          />
        </article>
      </section>
      <section class="grid gap-5 grid-cols-1 pb-8">
        <section>
          <article class="bg-white p-5 flex justify-between rounded-xl shadow-cardShadow">
            <p class="label-text-myriad">Pay Total</p>
            <p class="label-text-medium">{{ $filters.formatMoney(queryData.amount) }}</p>
          </article>
            <p v-if="params.errorProcessForPg" class="pt-5 text-sm font-blogger font-semibold text-center text-red-500">{{params.errorProcessForPg}}</p>
        </section>
        <!-- Select a Payment Method -->
        <section v-if="paymentMethods" class="grid gap-4 grid-cols-1">
          <p class="label-text" v-if="initiateTransactionCardInfoList?.length > 0">Other Payment Modes</p>
          <p class="label-text" v-else>Select a Payment Method</p>
          <section v-for="(data, index) in paymentMethods" :key="index">
            <!-- showDropDown PayTm  -->
            <details
              v-if="data?.displayName === 'Credit Card' && data.showDropDown ||
                data?.displayName === 'Net Banking' && data.showDropDown ||
                data?.displayName === 'Upi' && data.showDropDown ||
                data?.displayName === 'Wallet' && data.showDropDown ||
                data?.displayName === 'Debit Card' &&  data.showDropDown"
              name="idDetailsOpen"
              :open="data?.displayName === 'Upi' && data.showDropDown"
              class="bg-white rounded-xl shadow-cardShadow"
              @click="OpenDetails(index, data)"
            >
              <summary
                class="block pr-16 justify-between cursor-pointer marker-none list-none bg-details-arrow bg-no-repeat focus:outline-none outline-none p-4"
              >
                <div class="flex gap-2 items-center">
                  <img
                    :src="require(`@/assets/${
                      data?.displayName === 'Credit Card' ? 'creditcard' :
                      data?.displayName === 'Net Banking' ? 'netbanking' :
                      data?.displayName === 'Upi' ? 'upi' :
                      data?.displayName === 'Wallet' ? 'wallet' :
                      data?.displayName === 'Debit Card' ? 'debitcard' : 'wallet'
                    }.svg`)"
                    :alt="data.displayName"
                  />
                  <p class="label-text-textSecondary">{{ data.displayName }}</p>
                </div>
              </summary>
              <div v-if="data?.displayName != 'Net Banking' && data?.displayName != 'Debit Card'" class="pb-4 px-5 grid gap-7" @click.stop>
                <div
                    class="grid gap-2 text-textPrimary"
                >
                  <!-- Credit Card Section -->
                  <div v-if="data.displayName === 'Credit Card'" class="gap-4 scroll-box pb-2 flex">
                    <div class="flex gap-2 pt-2 text-errorColor font-blogger">
                        <img src="../assets/cross-error-red.svg" alt="error-cross-icon" />
                        <p>This service is not available yet!!</p>
                    </div>
                  </div>
                  <!-- Upi Section -->
                  <form @submit.prevent="isUpiValid ? upiIdFun(data) : ''" @input="handleInputUpi"  v-else-if="data.displayName === 'Upi'" class="grid gap-5">
                    <article class="">
                      <span class="flex gap-4">
                        <label
                          for="mobile"
                          class="border-2 w-full pl-4 pr-2 bg-white opacity-100 items-center text-base gap-2 rounded-full flex font-blogger font-semibold relative justify-between"
                        >
                          <input
                            type="input"
                            inputmode="numeric"
                            placeholder="Enter UPI ID"
                            class="grid w-full h-10 bg-white focus:outline-none focus:ring-0 text-base font-myriad placeholder-greyButtonColor border-none"
                            required
                            v-model="params.upi"
                            @input="validateUpiIdRealTime"
                            @cut.prevent
                            autofocus
                            autocomplete="off"
                          />
                          <button
                            variant="primary"
                            :loading="isSpinLoading"
                            type="submit"
                            :class="isUpiValid ? 'bg-primaryLight text-white w-28 h-7 rounded-full text-xxs shadow-payNowShadow' :
                              'bg-greyBtnColor text-white w-28 h-7 rounded-full text-xxs'"
                          >
                            Pay
                          </button>
                        </label>
                      </span>
                    </article>
                    <div v-if="data.displayName === 'Upi' && UpiErrorEnable" class="flex gap-2 text-errorColor text-xs font-blogger">
                      <img src="../assets/cross-error-red.svg" width="12" height="14" alt="error-cross-icon" />
                      <p>UPI entered is incorrect, please try again!!</p>
                    </div>
                    <article class="grid grid-cols-6 secondary-heading-text-blogger justify-items-center">
                      <div v-for="(data, index) in upiPostFix" :key="index">
                      <p :class="{ 'text-primaryLight': selectedIndex === index }" @click="handleUpiClick(data.name, index)">{{ data.name }}</p>
                      </div>
                    </article>
                    <article class="flex gap-4 justify-center secondary-heading-text text-center">
                      <div class="grid gap-1">
                        <span class="grid border-2 w-12 h-12 rounded-xl justify-center items-center">
                          <img src="../assets/gpay-icon.png" width="32" height="28" alt="G pay"/>
                        </span>
                        <p>G Pay</p>
                      </div>
                      <div class="grid gap-1">
                        <span class="grid border-2 w-12 h-12 rounded-xl justify-center items-center">
                          <img src="../assets/phonepay-icon.png" width="32" height="28" alt="Phone Pay"/>
                        </span>
                        <p>Phone Pay</p>
                      </div>
                      <div class="grid gap-1">
                        <span class="grid border-2 w-12 h-12 rounded-xl justify-center items-center">
                          <img src="../assets/paytm-icon.png" width="32" height="28" alt="Paytm"/>
                        </span>
                        <p>Paytm</p>
                      </div>
                    </article>
                  </form>
                </div>
              </div>
            </details>
            <!-- Razer pay  -->
            <div @click="closeDetails" v-else class="grid gap-3">
              <button
                @click="makePayment(data)"
                class="flex bg-white rounded-xl shadow-cardShadow p-4 gap-2 items-center focus:ring-0 bg-details-arrow bg-no-repeat focus:outline-none outline-none"
                :class="{
                    ' cursor-not-allowed opacity-50': loading,
                }"
                :disabled="loading"
                >
                <img
                  :src="require(`@/assets/${
                  data?.displayName === 'Credit Card' ? 'creditcard' :
                  data?.displayName === 'Net Banking' ? 'netbanking' :
                  data?.displayName === 'Upi' ? 'upi' :
                  data?.displayName === 'Wallet' ? 'wallet' :
                  data?.displayName === 'Debit Card' ? 'debitcard' : 'wallet'
                  }.svg`)"
                  :alt="data.displayName"
                />
                <p class="label-text-textSecondary">{{ data.displayName }}</p>
              </button>
            </div>
          </section>
        </section>
      </section>
    </main>
    <!-- Spin Loader -->
    <spin-loader :spinLoading="isSpinLoading"/>
  </template>
  <script>
  import { mapGetters } from 'vuex';
  import SpinLoader from '../components/spinLoader.vue';

  export default {
    name: 'Payment Options',
    data() {
      return {
        queryData: this.$route.params,
        isUpiValid: false,
        selectedIndex: undefined,
        paymentMethods: undefined,
        loading: undefined,
        totalAmount: false,
        otherAmount: false,
        maximumAmountError: false,
        minAmountError: false,
        mimAmount: false,
        isLoading: undefined,
        redirectPaytmPageContent: undefined,
        initiateTransactionCardInfoList: undefined,
        referenceNo: undefined,
        radioBtnEnable: false,
        UpiErrorEnable: false,
        redirectPaytmPage: undefined,
        isLoadingSaveCard: undefined,
        radioBtnEnableIndex: undefined,
        saveCardRadioData: undefined,
        isSpinLoading: undefined,
        isOpenDetails: undefined,
        isOpenDetailsIndex: undefined,
        enableCvvSaveCard: true,
        params: {
          amount: undefined,
          upi: undefined,
          cardNumber: undefined,
          expiryDate: undefined,
          cvvInput: undefined,
          bankName: undefined,
          cvvInputSaveCard: undefined,
          errorProcessForPg: undefined,
        },
        otherPayMent: [
          { name: "UPI", img: "upi-pg" },
          { name: "Net Banking", img: "net-banking-pg" },
          { name: "Debit Card", img: "debit-card-pg" }
        ],
        upiPostFix: [
          { name: '@paytm' },
          { name: '@ybl' },
          { name: '@apl' },
          { name: '@axisb' },
          { name: '@icici' },
          { name: '@okicici' },
        ],
        pageVisible: undefined,
        redirectTo: localStorage.getItem('setRedirectGPayFlow')
      };
    },
    components: { SpinLoader },
    computed: {
      ...mapGetters(['applicationId', 'creditAccountInfo', 'flagsData', 'transactionId', 'marketplaceId']),
    },
    mounted() {
      this.init();
    },
    created() {
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },
    beforeUnmount() {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },
    methods: {
      init() {
        if (!this.queryData.amount) {
          this.$router.push({
            name: 'Credit Statement Pay Now',
            query: {
              transactionId: this.transactionId
            },
          });
        }
        this.params.amount = this.queryData.amount;
        this.totalAmount = true;
        this.processForPayment();
      },
      makePayment(method) {
        this.isSpinLoading = true;
        this.$store
          .dispatch('processTransaction', {
            rowData: {
              paymentMethod: method.displayName,
              nbfcPgPaymentId: method.nbfcPgPaymentId,
              transactionId: [
                  this.queryData?.id
                ],
              amount: this.params.amount,
              productFlow: "",
              deviceType: "microApp"
            },
          })
          .then((response) => {
            window.microapps.openUrl({ url: response.paymentUrl }); // microapps.openUrl
            this.isSpinLoading = false;
          })
          .catch(() => {
            this.isSpinLoading = false;
          });
      },
      handleInputCvvSaveCard(e) {
        const input = e.target.value;
        if (input.length > 4) {
          this.params.cvvInputSaveCard = input.slice(0, -1);
        } else if (input.length > 2) {
          this.enableCvvSaveCard = false;
        } else if (input.length < 3) {
          this.enableCvvSaveCard = true;
        }
      },
      handleInputUpi() {
        this.UpiErrorEnable = false;
      },
      isNumber(evt) {
        const event = evt || window.event;
        const charCode = event.which ? event.which : event.keyCode;
        if ((charCode < 48 || charCode > 57) && charCode !== 46) {
          event.preventDefault();
          return false;
        }
        return true;
      },
      handleInput(e) {
        const input = e.target;
        this.maximumAmountError = false;
        this.minAmountError = false;
        if (input.value === this.queryData.amount) {
          this.totalAmount = true;
          this.otherAmount = false;
        } else if (input.value === this.queryData.minimumDueAmount) {
          this.otherAmount = false;
          this.totalAmount = false;
          this.mimAmount = true;
        } else if (input.value === '') {
          this.otherAmount = false;
          this.totalAmount = false;
          this.maximumAmountError = false;
          this.minAmountError = false;
          this.mimAmount = false;
        } else {
          this.otherAmount = true;
          this.totalAmount = false;
          this.mimAmount = false;
        }
      },
      processForPayment() {
        this.isSpinLoading = true;
        this.params.errorProcessForPg = '';
        if (Math.round(this.params.amount * 100) > Math.round(this.queryData.amount * 100)) {
          this.maximumAmountError = true;
        } else if (Math.round(this.params.amount * 100) < Math.round(this.queryData.minimumDueAmount * 100)) {
          this.minAmountError = true;
        } else {
          this.isLoading = true;
            const params = {
            rowData: {
              amount: this.params.amount,
              currency: "INR",
              transactionId: [
                this.queryData?.id
              ],
              channelType: "WEB"
            },
          };
          this.$store
            .dispatch('initiateTransaction', params)
            .then((response) => {
              this.isSpinLoading = false;
              this.paymentMethods = response?.paymentOptions;
              this.initiateTransactionCardInfoList = response?.cardInfoList;
              this.referenceNo = response?.referenceNo;
              this.radioBtnEnable = true;
              this.params.errorProcessForPg = '';
              this.maximumAmountError = '';
              this.minAmountError = '';
              this.isLoading = false;
            })
            .catch((err) => {
              this.isSpinLoading = false;
              this.params.errorProcessForPg = err.message;
              this.isLoading = false;
            });
        }
      },
      saveCardRadio(index, data) {
        this.radioBtnEnable = true;
        this.params.cvvInputSaveCard = '';
        this.params.upi = '';
        this.params.cardNumber = '';
        this.params.expiryDate = '';
        this.params.cvvInput = '';
        this.radioBtnEnableIndex = index;
        this.saveCardRadioData = data;
        this.isOpenDetails = false;
        const details = document.getElementsByName("idDetailsOpen");
        const lg = details.length;
        for (let i = 0; i < lg; i += 1) {
            details[i].open = false;
        }
      },
      cvvFun(data) {
        this.isLoadingSaveCard = true;
        const params = {
          rowData: {
            nbfcPgPaymentId: data.nbfcPgPaymentId,
            transactionId: [
                this.queryData?.id
            ],
            amount: this.params.amount,
            productFlow: "generic",
            deviceType: "microApp",
            paymentMethod: "DebitCard",
            cardInfo: {
              cvv: this.params.cvvInputSaveCard,
              savedCardId: this.saveCardRadioData.savedCardId
            },
            referenceNo: this.referenceNo,
          },
        };
        this.$store
          .dispatch('processTransaction', params)
          .then((response) => {
            this.isLoadingSaveCard = false;
            this.redirectPaytmPage = response.formDetails;
            this.redirectPaytmPageContent = Object.entries(response.formDetails.content);
            setTimeout(() => {
              document.forms[4].submit();
            }, 0);
          })
          .catch(() => {
            this.isLoadingSaveCard = false;
        });
      },
      upiIdFun(data) {
        const pattern = /[a-zA-Z0-9_]{3,}@[a-zA-Z]{3,}/;
        if (!pattern.test(this.params.upi)) {
          this.UpiErrorEnable = true;
        } else {
          this.isSpinLoading = true;
          const params = {
            rowData: {
            nbfcPgPaymentId: data.nbfcPgPaymentId,
            transactionId: [
              this.queryData?.id
            ],
            amount: this.params.amount,
            productFlow: "generic",
            deviceType: "microApp",
              referenceNo: this.referenceNo,
              paymentMethod: "Upi",
              upiInfo: {
                vpa: this.params.upi,
              },
            },
          };
          this.$store
            .dispatch('processTransaction', params)
            .then((response) => {
              this.redirectPaytmPage = response.formDetails;
              this.redirectPaytmPageContent = Object.entries(response.formDetails.content);
              if (this.flagsData?.showPaytmCard) {
                setTimeout(() => {
                  document.forms[3].submit();
                }, 0);
              } else {
                setTimeout(() => {
                  document.forms[2].submit();
                }, 0);
              }
              this.isSpinLoading = false;
            })
            .catch((err) => {
              if (err.message === 'Invalid VPA.') {
                this.UpiErrorEnable = true;
              }
              this.isSpinLoading = false;
            });
        }
      },
      validateUpiId(upiId) {
        // Regular expression pattern for UPI ID validation
        const upiPattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9.-]{3,}$/;

        // Use the test method to check if the upiId matches the pattern
        return upiPattern.test(upiId);
      },
      validateUpiIdRealTime() {
        const upiId = this.params.upi; // Get the UPI ID from the input field
        this.isUpiValid = this.validateUpiId(upiId); // Update the validation flag
        let isTagAvailable = false;
        let tagIndex = -1;
        this.upiPostFix.forEach((tag, index) => {
          if (upiId.includes(tag.name)) {
            isTagAvailable = true;
            tagIndex = index;
          }
        });
        if (isTagAvailable) {
          this.selectedIndex = tagIndex;
        } else {
          this.selectedIndex = tagIndex;
        }
      },
      closeDetails() {
        this.radioBtnEnable = false;
        this.params.upi = '';
        this.params.cardNumber = '';
        this.params.expiryDate = '';
        this.params.cvvInput = '';
        const details = document.getElementsByName("idDetailsOpen");
        const lk = details.length;
        for (let i = 0; i < lk; i += 1) {
          details[i].open = false;
        }
      },
      OpenDetails(index, data) {
        if (index === 1) {
          this.$router.push({
            name: 'NetBanking',
            params: {
              amount: this.queryData.amount,
              txnAmount: this.queryData.txnAmount,
              txnConvenienceFees: this.queryData.txnConvenienceFees,
              txnLateFees: this.queryData.txnLateFees,
              txnPenaltyFees: this.queryData.txnPenaltyFees,
              minimumDueAmount: this.queryData.minimumDueAmount,
              id: this.queryData.id,
              marketplaceName: this.queryData.marketplaceName,
              txnDueDate: this.queryData.txnDueDate,
              overdueDays: this.queryData.overdueDays,
              txnDate: this.queryData.txnDate
            },
          });
        } else if (index === 2) {
          this.$router.push({
            name: 'Debit Card',
            params: {
              amount: this.queryData.amount,
              txnAmount: this.queryData.txnAmount,
              txnConvenienceFees: this.queryData.txnConvenienceFees,
              txnLateFees: this.queryData.txnLateFees,
              txnPenaltyFees: this.queryData.txnPenaltyFees,
              minimumDueAmount: this.queryData.minimumDueAmount,
              id: this.queryData.id,
              marketplaceName: this.queryData.marketplaceName,
              txnDueDate: this.queryData.txnDueDate,
              overdueDays: this.queryData.overdueDays,
              txnDate: this.queryData.txnDate,
              nbfcPgPaymentId: data.nbfcPgPaymentId,
              referenceNo: this.referenceNo
            },
          });
        }

        this.isOpenDetailsIndex = index;
        this.radioBtnEnable = false;
        this.params.upi = '';
        this.params.cardNumber = '';
        this.params.expiryDate = '';
        this.params.cvvInput = '';
        // close Details
        const details = document.getElementsByName("idDetailsOpen");
        const lk = details.length;
          for (let i = 0; i < lk; i += 1) {
            details[i].open = false;
          }
        // Close RadioButton
        const checkbox = document.getElementsByName("option");
        const lg = checkbox.length;
        for (let i = 0; i < lg; i += 1) {
            checkbox[i].checked = false;
        }
      },
      handleUpiClick(tag, index) {
        if (this.params.upi) {
          this.selectedIndex = index;
          this.UpiErrorEnable = undefined;
          // Split the input value by the "@" symbol and take the first part
          const inputParts = this.params.upi.split('@');
          if (inputParts.length > 1) {
            // If there is an existing tag, replace it with the new tag
            // this.isUpiValid = this.validateUpiId(inputParts[0] + tag);
            this.params.upi = inputParts[0] + tag;
          } else {
            // If there is no existing tag, simply add the new tag
            this.params.upi += tag;
          }
          this.isUpiValid = this.validateUpiId(this.params.upi);
        }
      },
      handleVisibilityChange() {
        if (document.hidden) {
          this.pageVisible = false;
        } else {
          if (this.redirectTo === 'Credit Statement') {
            this.$router.push({ name: 'Credit Statement' });
          } else {
            this.$router.push({
              name: 'Suppliers Details',
              query: {
                marketplaceId: this.marketplaceId,
                showBackArrow: true
              }
            });
          }
          this.pageVisible = true;
        }
      },
    },
  };
  </script>
  <style lang="scss" scoped>
    .scroll-box {
    @apply flex overflow-x-auto;
    scroll-snap-type: x mandatory;
    scrollbar-width: thin;
    &::-webkit-scrollbar {
      width: 2px;
      height: 5px;
      background-color: rgba(245, 246, 251, var(--tw-bg-opacity)); /* or add it to the track */
    }
    &::-webkit-scrollbar-thumb {
      background: #c4c4c4;
      border-radius: 2rem;
    }
  }
  </style>
